/**
 * External dependencies
 */
import React from "react";
import { Box, Text } from "@towersystems/towersystems-design-system";
/**
 * Internal dependencies
 */
import Button from "components/button";
import Section from "components/section";

/**
 * Style dependencies
 */
import "./styles.scss";

const TrashData = (props) => {
  return (
    <Section>
      <Box display="flex" alignItems="center" justifyContent="spaceBetween">
        <Box>
          <Text size="xsmall" weight="medium">
            Trash all sales data.
          </Text>
          <Text size="xsmall">warning. this cannot be undone.</Text>
        </Box>
        <Button>Delete</Button>
      </Box>
    </Section>
  );
};

export default TrashData;
